<template>
  <b-modal ref="modal" v-bind="$attrs" :id="id" :title="modalTitle" @ok="handleOk" title-class="font-18" lazy>
    <component
      :is="form"
      v-bind="formProps"
      v-on="formListeners"
      v-model="model"
      :is-valid.sync="isValid"
      :errors="errors"
      ref="form"
      is-modal="true"
    >
    </component>
    <template #modal-footer="{ ok, cancel}">
      <b-button size="md" variant="outline-dark" @click="cancel()">
        Batal
      </b-button>
      <b-button size="md" variant="primary" @click="ok()" :disabled="loading">
        <i v-if="loading" class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Simpan
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import FormsModel from "@/components/forms/model";
import Swal from "sweetalert2";

export default {
  name: "modal-create",
  props: {
    id: {type: String, required: true},
    modalTitle: {default() { return this.lodash.startCase(this.$t('models.singular')) }},
    resourceRoute: {default: 'models'},
    modelVariable: {default: 'model'},
    form: {
      type: Object, default: function() {
        return FormsModel;
      }
    },
    formProps: {
      type: Object, default: function () {
        return {}
      }
    },
    formListeners: {
      type: Object, default: function () {
        return {}
      }
    },
    initialValue: {type: Object, default() { return {} }}
  },
  data() {
    return {
      loading: false,
      isValid: true,
      model: {
        ...this.initialValue
      },
      errors: {}
    }
  },
  mounted() {
    if (this.getModelKey(this.model))
      this.fetchModel()
  },
  watch: {
    'initialValue.type': function (n, o) {
      if (!this.lodash.isEqual(n,o)) {
        this.model.type = n
      }
    }
  },
  methods: {
    getModelKey(value) {
      return value[this.modelKey || 'id'];
    },
    getModelName(value) {
      return value['name'] || this.getModelKey(value)
    },
    fetchModel() {
      return Promise.resolve({ data: {} })
    },
    handleBack() {
      this.$refs.modal.hide()
    },
    failedAlert(error) {
      if (error.response && error.response.status === 422) {
        this.errors = (error.response.data || {}).errors;
        const key = Object.keys(this.errors).find((k) => this.errors[k].length)
        const errorMessage = key && this.errors[key][0]
        return Swal.fire({
          title: this.$t('Failed') + '!',
          text: errorMessage || (error.response && (error.response.data || {}).message) || error.message,
          type: 'danger',
          confirmButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        })
      }
      return Swal.fire({
        title: this.$t('Failed') + '!',
        text: (error.response && (error.response.data || {}).message) || error.message,
        type: 'danger',
        confirmButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      })
    },
    store(value) {
      return Promise.resolve({ data: value })
    },
    handleStore(value) {
      this.store(value).then(({ data: { data } }) => {
        // return Swal.fire({
        //   icon: "success",
        //   title: this.$t('Success'),
        //   showConfirmButton: false,
        //   timer: 1500
        // })
        let something = this.getModelName(value);
        let id = (data || {}).id;
        return Swal.fire({
          title: this.$t('Success') + '!',
          text: this.$t(`You've added {something} with id {id}`, {something, id}),
          type: 'success',
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          this.$emit('created', data)
          this.$refs.modal.hide()
        })
      }).catch((error) => this.failedAlert(error))
    },
    handleOk(event) {
      event.preventDefault()
      if (!('validateAll' in this.$refs.form)) return;
      this.$refs.form.validateAll().then((isValid) => {
        this.isValid = isValid
        if (isValid) this.$nextTick(() => {
          this.handleStore(this.model)
        })
      })
    }
  },
}
</script>
